import type {
    AutomatedEmailsState,
} from '@store/features/automatedEmails/reducers';
import automatedEmailsReducer from '@store/features/automatedEmails/reducers';
import dashboardReducer from '@store/features/dashboard/reducers';
import emailAnalyticsReducer from '@store/features/emailAnalytics/reducers';
import emailAuditReducer from '@store/features/emailAudit/reducers';
import type {
    JobApplicantState,
} from '@store/features/jobApplicants/reducers';
import jobApplicantsReducer from '@store/features/jobApplicants/reducers';
import type {
    LoginUserProfileState,
} from '@store/features/loginUserProfile/reducers';
import loginUserProfileReducer from '@store/features/loginUserProfile/reducers';
import type { UiState } from '@store/features/ui/reducers';
import uiReducer from '@store/features/ui/reducers';
import { combineReducers } from 'redux';

export interface RootState {
  loginUserProfile: LoginUserProfileState;
  jobApplicants: JobApplicantState;
  automatedEmails: AutomatedEmailsState;
  emailAnalytics: ReturnType<typeof emailAnalyticsReducer>;
  emailAudit: ReturnType<typeof emailAuditReducer>;
  dashboard: ReturnType<typeof dashboardReducer>;
  ui: UiState;
}

const rootReducer = combineReducers({
  loginUserProfile: loginUserProfileReducer,
  jobApplicants: jobApplicantsReducer,
  automatedEmails: automatedEmailsReducer,
  emailAnalytics: emailAnalyticsReducer,
  emailAudit: emailAuditReducer,
  dashboard: dashboardReducer,
  ui: uiReducer,
});

export default rootReducer;
